import React from 'react';
import '../components/components.css';

import Header from '../components/Header';
import Footer from '../components/Footer';
import AskContent from '../components/AskContent';

export default function Ask() {
  return (
    <div className='container mt-2'>
      <Header />
      <AskContent />
      <hr />
      <Footer />
    </div>
  );
}
